import { render, staticRenderFns } from "./ai-server.vue?vue&type=template&id=5cff0d6b&scoped=true"
import script from "./ai-server.vue?vue&type=script&lang=js"
export * from "./ai-server.vue?vue&type=script&lang=js"
import style0 from "./ai-server.vue?vue&type=style&index=0&id=5cff0d6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff0d6b",
  null
  
)

export default component.exports